/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FundingRequestSearchQueryStatus {
  DRAFT = "DRAFT",
  NEW = "NEW",
  OPENED = "OPENED",
  FOR_PAYMENT = "FOR_PAYMENT",
  CLOSED = "CLOSED",
}

export function FundingRequestSearchQueryStatusFromJSON(json: any): FundingRequestSearchQueryStatus {
  return FundingRequestSearchQueryStatusFromJSONTyped(json, false);
}

export function FundingRequestSearchQueryStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestSearchQueryStatus {
  return json as FundingRequestSearchQueryStatus;
}

export function FundingRequestSearchQueryStatusToJSON(value?: FundingRequestSearchQueryStatus | null): any {
  return value as any;
}
